<template>
  <div style="width: 100%">
    <v-data-table      
      :headers="headers"
      :items="listUsers"
      item-key="rut"
      class="elevation-1"
      :loading="loading"
      loading-text="Cargando... Favor de esperar"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <CreateUser></CreateUser>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row align="center" >
          <EditUser :userData="item"></EditUser>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CreateUser from "./CreateUser";
import EditUser from "./EditUser";
import { UserService } from '../../../services/models/user';
import {eventBus} from '../../../main';

export default {
  components: {
    CreateUser,
    EditUser,    
  },
  data() {
    return {
      search: "",
      listUsers: [],
      loading: false,
      headers: [
        { text: "Nombre", value: "name", align: "start", sortable: true },
        { text: "Apellido Paterno", value: "pather_lastname", sortable: true },
        { text: "Apellido Materno", value: "mother_lastname", sortable: true },
        { text: "RUT", value: "run", sortable: true },
        { text: "Acciones", value: "actions", sortable: true },
      ],
    };
  },
  methods: {
    async chargeListUsers() {
      this.loading = true;
      this.listUsers = await UserService.getAll();
      this.loading = false;
    },
  },
  mounted() {
    this.chargeListUsers();
    eventBus.$on('loadTableUsers',()=>{
      this.chargeListUsers();
    })
  },
};
</script>